import HowItWorksView from './HowItWorks.view';
export * from './HowItWorks.view';

export const HowItWorks = (props) => HowItWorksView(props);

export default HowItWorks;

